export default __webpack_public_path__ + "static/media/option-bloed-plast.3f5bc968.svg";